// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__jSHWH","content":"Consent_content__2QQac","footer":"Consent_footer__3BVf6"};